function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FrenchPolynesiaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#BF2714",
        fillRule: "evenodd",
        d: "M0 3v4.5h24V3H0ZM0 16.5V21h24v-4.5H0Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "10",
        height: "10",
        x: "7",
        y: "7",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#FA8F21",
          fillRule: "evenodd",
          d: "m10.528 13.031.33-5.42C8.926 8.009 7.5 9.472 7.5 12.154c0 1.415.94 1.247 2.329.998.222-.04.456-.082.7-.12Zm2.143-5.49.766 5.508c.277.05.542.108.792.163 1.357.295 2.271.494 2.271-1.059 0-2.768-1.662-4.346-3.83-4.613Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#5277B9",
          fillRule: "evenodd",
          d: "M12 16.5c2.485 0 4.5-1.343 4.5-3s-2.015-3-4.5-3-4.5 1.343-4.5 3 2.015 3 4.5 3Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#5277B9",
          fillRule: "evenodd",
          d: "M7.873 13.202a.098.098 0 0 1 .143-.115l.413.24a.099.099 0 0 0 .09.004l.742-.347a.098.098 0 0 1 .1.009l.77.556 1.054-.567a.098.098 0 0 1 .086-.004l.82.357c.027.01.057.01.082-.002l.738-.355a.099.099 0 0 1 .08-.003l.903.361c.026.01.056.01.08-.003l.712-.352a.098.098 0 0 1 .089.001l.66.346c.029.015.064.014.093-.002l.445-.252a.098.098 0 0 1 .143.111l-.096.364H7.982l-.11-.347ZM7.87 14.09a.098.098 0 0 1 .145-.113l.388.233a.099.099 0 0 0 .094.004l.709-.344a.098.098 0 0 1 .102.01l.74.554 1.015-.566a.099.099 0 0 1 .088-.003l.787.354a.098.098 0 0 0 .084-.002l.707-.353a.098.098 0 0 1 .081-.003l.867.36c.027.01.057.01.082-.004l.681-.349a.098.098 0 0 1 .092.001l.63.342c.03.017.067.016.097-.001l.418-.246a.098.098 0 0 1 .146.11l-.093.36H7.977l-.106-.344ZM8.018 14.68a.098.098 0 0 1 .145-.113l.388.233a.098.098 0 0 0 .094.005l.709-.344a.098.098 0 0 1 .101.01l.741.554 1.015-.566a.098.098 0 0 1 .088-.004l.786.354a.098.098 0 0 0 .084-.002l.707-.353a.098.098 0 0 1 .082-.002l.867.358c.026.012.056.01.082-.003l.68-.349a.098.098 0 0 1 .093.001l.63.342c.03.017.067.016.097-.001l.418-.246a.098.098 0 0 1 .145.11l-.093.36H8.124l-.106-.344ZM8.904 15.27a.098.098 0 0 1 .144-.113l.388.234a.099.099 0 0 0 .094.004l.709-.344a.098.098 0 0 1 .102.01l.74.554 1.015-.566a.099.099 0 0 1 .088-.004l.786.354a.098.098 0 0 0 .085-.002l.706-.352a.098.098 0 0 1 .082-.003l.867.359c.026.01.057.01.082-.004l.68-.349a.098.098 0 0 1 .093.001l.63.343c.03.016.067.015.097-.002l.418-.246a.098.098 0 0 1 .145.11l-.092.36H9.01l-.106-.344ZM7.723 16.008a.098.098 0 0 1 .145-.113l.388.233a.098.098 0 0 0 .094.005l.708-.344a.098.098 0 0 1 .102.01l.741.553 1.015-.566a.098.098 0 0 1 .088-.003l.786.354a.098.098 0 0 0 .084-.002l.707-.353a.098.098 0 0 1 .082-.002l.867.358c.026.011.056.01.082-.003l.68-.349a.098.098 0 0 1 .092.001l.63.342c.031.017.068.016.098-.001l.418-.246a.098.098 0 0 1 .145.11l-.093.36H7.83l-.106-.344Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "red",
          d: "M9.5 10.084h.75l-.017 2.964c.126.4.306.556.584.556v.75c-.633 0-1.081-.39-1.317-1.193v-3.077ZM14.394 10.084h-.75l.017 2.964c-.126.4-.305.556-.584.556v.75c.634 0 1.082-.39 1.317-1.193v-3.077Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "red",
          fillRule: "evenodd",
          d: "M12.543 8.181s-1.244-.325-1.244.5v2.597l1.45.43V9.587s-.724-.443-.724-.79c0-.346.518-.615.518-.615Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#212124",
          strokeWidth: ".5",
          d: "m10.45 12.668.473-.604M10.882 12.648l-.454-.608M11.129 12.668l.473-.604M11.56 12.648l-.453-.608M11.778 12.668l.473-.604M12.21 12.648l-.454-.608M12.457 12.668l.473-.604M12.888 12.648l-.453-.608M13.136 12.668l.473-.604M13.567 12.648l-.453-.608"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=FrenchPolynesia.js.map